import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CallUpdateEnforcementLevelApi, chain } from "@insite/client-framework/Store/Pages/BudgetManagement/Handlers/SaveBudgetConfiguration";
import { updateEnforcementLevel } from "@store/Services/CustomersService"; // Poolcorp Custom Code

replaceInChain(chain, CallUpdateEnforcementLevelApi, async props => {
    props.updateEnforcementLevelApiResult = await updateEnforcementLevel( // Poolcorp Custom Import
        props.parameter.updateEnforcementLevelApiParameter,
    );
    props.hadError = !props.updateEnforcementLevelApiResult;
});
